import { Component, OnInit } from '@angular/core';
import {EditEvent, GridDataResult, RemoveEvent} from "@progress/kendo-angular-grid";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {NumeroWhatsapp} from "../../pedidos/objetos/NumeroWhatsapp";
import {NumerosWhatsappService} from "../../services/numeros-whatsapp.service";
import {NovaFormaDePagamentoComponent} from "../../formas-de-pagamento/nova-forma-de-pagamento/nova-forma-de-pagamento.component";
import {NovoNumeroWhatsappComponent} from "../novo-numero-whatsapp/novo-numero-whatsapp.component";
import {DialogService} from "@progress/kendo-angular-dialog";
import {ActivatedRoute, Router} from "@angular/router";
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {extensaoDoNumero} from "../extensoes-whatsapp";
import {WhatsappV4Service} from "../../services/whatsapp-v4.service";

@Component({
  selector: 'app-cadastro-numero-whatsapp',
  templateUrl: './cadastro-numero-whatsapp.component.html',
  styleUrls: ['./cadastro-numero-whatsapp.component.scss']
})
export class CadastroNumeroWhatsappComponent implements OnInit {
  loading: any;
  empresa: any;
  objetos: Array<NumeroWhatsapp> = [];
  carregando: any;
  modalDeletar = false;
  objetoApagar: NumeroWhatsapp;
  numeroPrincipal: NumeroWhatsapp = new NumeroWhatsapp();
  numeroCampanhas: NumeroWhatsapp = new NumeroWhatsapp();
  msgSucesso = '';
  campanhasRadioValue: string = '';
  modoSuperadmin = false;
  podeAlterarVersao = false;

  constructor(private router: Router, private route: ActivatedRoute, private constantsService: ConstantsService,
              private numerosWhatsappService: NumerosWhatsappService,
              private dialogService: DialogService, private empresasService: EmpresasService,
              private whatsappV4Service: WhatsappV4Service) {
    this.loading = true;
  }

  ngOnInit(): void {
    const idEmpresa = this.route.snapshot.params.idEmpresa;
    this.modoSuperadmin = !!idEmpresa;
    const usuario = this.route.parent?.snapshot.data.user;
    this.podeAlterarVersao = !!(usuario && (usuario.admin || usuario.superadmin));

    if (idEmpresa) {
      this.empresasService.obtenha(idEmpresa).then((resp: any) => {
        this.definaEmpresa(resp.data);
      });
      return;
    }

    this.constantsService.empresa$.subscribe((empresa: any) => {
      if (empresa && !this.empresa) {
        this.definaEmpresa(empresa);
      }
    });
  }

  extensaoDoNumero = extensaoDoNumero;

  editar(numeroWhatsapp: NumeroWhatsapp) {
    const dimensoes = this.dimensoesDaDialog();
    const windowRef = this.dialogService.open({
      title: 'Alterar número WhatsApp',
      content: NovoNumeroWhatsappComponent,
      minWidth: 250,
      width: dimensoes.width,
      maxHeight: dimensoes.maxHeight,
      cssClass: 'numero-whatsapp-dialog'
    });

    const telaNovaFormaDePagamento: NovoNumeroWhatsappComponent = windowRef.content.instance;

    telaNovaFormaDePagamento.empresa = this.empresa;
    telaNovaFormaDePagamento.podeAlterarVersao = this.podeAlterarVersao;
    telaNovaFormaDePagamento.windowRef = windowRef;
    telaNovaFormaDePagamento.numeroWhatsapp = Object.assign({}, numeroWhatsapp);
    telaNovaFormaDePagamento.carreguePolitica();

    windowRef.result.subscribe((result: any) => {
      this.numerosMudaram();
    });
  }

  abraDialogRemover(numero: NumeroWhatsapp) {
    this.objetoApagar = numero;

    this.modalDeletar = true;
  }

  onFilter($event: Event) {

  }

  novo() {
    const dimensoes = this.dimensoesDaDialog();

    const windowRef = this.dialogService.open({
      title: 'Adicionar número WhatsApp',
      content: NovoNumeroWhatsappComponent,
      minWidth: 250,
      width: dimensoes.width,
      maxHeight: dimensoes.maxHeight,
      cssClass: 'numero-whatsapp-dialog'
    });

    const telaNovaFormaDePagamento: NovoNumeroWhatsappComponent = windowRef.content.instance;
    telaNovaFormaDePagamento.empresa = this.empresa;
    telaNovaFormaDePagamento.podeAlterarVersao = this.podeAlterarVersao;
    telaNovaFormaDePagamento.windowRef = windowRef;
    telaNovaFormaDePagamento.carreguePolitica();

    windowRef.result.subscribe((result: any) => {
      this.numerosMudaram();
    });
  }

  private dimensoesDaDialog(): {width: number, maxHeight: number} {
    const margemHorizontal = window.innerWidth > 600 ? 64 : 16;
    const margemVertical = window.innerHeight > 700 ? 96 : 48;

    return {
      width: Math.min(1080, window.innerWidth - margemHorizontal),
      maxHeight: window.innerHeight - margemVertical
    };
  }

  close(status: string) {
    if( status === 'sim') {
      this.numerosWhatsappService.removaWhatsapp(this.objetoApagar, this.empresa).then( () => {
        this.objetoApagar = null;
        this.modalDeletar = false;

        this.numerosMudaram();
      });
    } else {
      this.objetoApagar = null;
      this.modalDeletar = false;
    }
  }

  voltar() {
    const destino = this.modoSuperadmin
      ? '/superadmin/empresas/' + this.empresa.id
      : '/admin/loja';

    this.router.navigate([destino]).then( () => {});
  }

  mudarParaPrincipal(numeroClicado: NumeroWhatsapp) {
    for( let numero of this.objetos ) {
      numero.principal = false;
    }

    this.numeroPrincipal = numeroClicado;
    this.numeroPrincipal.principal = true;
    this.numerosWhatsappService.marqueNumeroComoPrincipal(this.numeroPrincipal, this.empresa).then( (resposta) => {
      this.msgSucesso = resposta;
      this.recarregueEmpresaLogada();
    });
  }

  // Métodos de verificação
  isPrincipal(numero: NumeroWhatsapp): boolean {
    return this.numeroPrincipal?.id === numero.id;
  }

  isCampanhas(numero: NumeroWhatsapp): boolean {
    return this.numeroCampanhas?.id === numero.id;
  }

  isPrincipalECampanhas(numero: NumeroWhatsapp): boolean {
    return this.isPrincipal(numero) && this.isCampanhas(numero);
  }

  podeRemover(numero: NumeroWhatsapp): boolean {
    return !this.isPrincipal(numero) && !this.isCampanhas(numero);
  }

  identifiqueNumero(indice: number, numero: NumeroWhatsapp): any {
    return numero.id;
  }

  percentualUsado(numero: NumeroWhatsapp): number {
    if (!numero.limiteDiario || numero.usadoHoje < 0) {
      return 0;
    }

    return Math.min(100, Math.round((numero.usadoHoje / numero.limiteDiario) * 100));
  }

  classeDeUso(numero: NumeroWhatsapp): string {
    const percentual = this.percentualUsado(numero);

    if (percentual >= 90) {
      return 'uso-critico';
    }

    if (percentual >= 70) {
      return 'uso-atencao';
    }

    return '';
  }

  formateDuracao(segundos: number): string {
    const total = Math.max(0, Math.ceil(Number(segundos) || 0));
    const minutos = Math.floor(total / 60);
    const segundosRestantes = total % 60;

    if (minutos && segundosRestantes) {
      return minutos + 'min ' + segundosRestantes + 's';
    }

    if (minutos) {
      return minutos + 'min';
    }

    return segundosRestantes + 's';
  }

  formateHorario(numero: NumeroWhatsapp): string {
    if (numero.janelaInicioHora === numero.janelaFimHora) {
      return '24 horas';
    }

    return this.formateHora(numero.janelaInicioHora) + 'h–' + this.formateHora(numero.janelaFimHora) + 'h';
  }



  // Métodos de ação para campanhas (com toggle)
  mudarParaCampanhas(numero: NumeroWhatsapp) {
    // Se já é o número de campanhas, desmarca (toggle)
    if (this.isCampanhas(numero)) {
      this.numeroCampanhas = new NumeroWhatsapp();
      this.campanhasRadioValue = '';
      this.empresasService.removerNumeroWhatsappCampanhas(this.empresa)
        .then((resposta) => {
          this.msgSucesso = 'Campanhas voltarão a usar o número principal';
          this.carregueNumeros();
        })
        .catch((erro) => {
          this.msgSucesso = 'Erro ao remover número de campanhas: ' + erro;
        });
    } else {
      // Se não é o número de campanhas, marca como tal
      this.numeroCampanhas = numero;
      this.campanhasRadioValue = numero.whatsapp;
      this.empresasService.definirNumeroWhatsappCampanhas(this.empresa, numero.id)
        .then((resposta) => {
          this.msgSucesso = `Número ${numero.whatsapp} agora é usado para campanhas`;
          this.carregueNumeros();
        })
        .catch((erro) => {
          this.msgSucesso = 'Erro ao definir número para campanhas: ' + erro;
        });
    }
  }

  /** Número criado, alterado ou removido: recarrega a lista e a empresa logada (os menus mostram o número principal). */
  private numerosMudaram() {
    this.carregueNumeros();
    this.recarregueEmpresaLogada();
  }

  // No modo superadmin a tela edita outra loja: a empresa logada não muda.
  private recarregueEmpresaLogada() {
    if (!this.modoSuperadmin) this.constantsService.recarregueEmpresa();
  }

  private carregueNumeros() {
    this.numerosWhatsappService.obtenhaNumeros(this.empresa).then( (numeros) => {
      this.objetos = numeros;

      // Identificar número principal
      for( let numero of this.objetos ) {
        this.carreguePolitica(numero);

        if( numero.principal ) {
          this.numeroPrincipal = numero;
        }
      }

      // Identificar número de campanhas usando a propriedade usadoParaCampanhas
      const numeroCampanhas = this.objetos.find(n => n.usadoParaCampanhas);
      if (numeroCampanhas) {
        this.numeroCampanhas = numeroCampanhas;
        this.campanhasRadioValue = numeroCampanhas.whatsapp;
      } else {
        this.numeroCampanhas = new NumeroWhatsapp();
        this.campanhasRadioValue = '';
      }
    });
  }

  private carreguePolitica(numero: NumeroWhatsapp) {
    numero.politicaCarregada = false;
    numero.politicaErro = false;

    this.whatsappV4Service.obtenhaPolitica(this.empresa, numero).then((resposta: any) => {
      const politica = resposta.politicaEfetiva;
      const resumoHoje = resposta.resumoHoje || {};

      numero.versaoExtensao = Number(resposta.versaoExtensao) || 3;
      numero.limiteDiario = politica.limiteDiario;
      numero.intervaloEnvioSegundos = politica.intervaloEnvioSegundos;
      numero.limitePorHoraCalculado = politica.limitePorHoraCalculado;
      numero.intervaloCampanhaSegundos = politica.intervaloCampanhaSegundos;
      numero.intervaloAutomacaoSegundos = politica.intervaloAutomacaoSegundos;
      numero.intervaloStatusPedidoSegundos = politica.intervaloStatusPedidoSegundos;
      numero.aplicarIntervaloConfirmacaoLoja = !!politica.aplicarIntervaloConfirmacaoLoja;
      numero.intervaloAvaliacaoSegundos = politica.intervaloAvaliacaoSegundos;
      numero.intervaloGlobalAutomaticoSegundos = politica.intervaloGlobalAutomaticoSegundos;
      numero.limiteAutomacaoPorHora = politica.limiteAutomacaoPorHora;
      numero.limiteCampanhaPorHora = politica.limiteCampanhaPorHora;
      numero.capacidadeDiariaCalculada = politica.capacidadeDiariaCalculada;
      numero.duracaoDaJanelaHoras = politica.duracaoDaJanelaHoras;
      numero.janelaInicioHora = politica.janelaInicioHora;
      numero.janelaFimHora = politica.janelaFimHora;
      numero.pausado = politica.pausado;
      numero.usadoHoje = resumoHoje.usadoHoje;
      numero.restanteHoje = resumoHoje.restanteHoje;
      numero.incertasHoje = resumoHoje.incertasHoje;
      numero.politicaCarregada = true;
    }).catch(() => {
      numero.politicaErro = true;
    });
  }

  private formateHora(hora: number): string {
    return ('0' + hora).slice(-2);
  }

  private definaEmpresa(empresa: any) {
    this.empresa = empresa;
    this.loading = false;
    this.carregueNumeros();
  }
}
